.box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: var(--size-2);
	background-color: var(--color-surface-elevated);
	padding: var(--size-2);
	padding-left: var(--size-4);
	border: var(--size-border) solid var(--color-border);
	border-radius: var(--radius-lg);
}

.value {
	flex: 1;
	min-width: 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	font-family: var(--font-mono);
}
